import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {
  createPagoMovilAccountService,
  deletePagoMovilAccountService,
  getPagoMovilAccountsService,
  updatePagoMovilAccountService,
} from "./pagoMovilAccounts.service";
import type {
  CreatePagoMovilAccountPayload,
  PagoMovilAccount,
  UpdatePagoMovilAccountPayload,
} from "./pagoMovilAccounts.types";

export const PAGO_MOVIL_ACCOUNTS_QUERY_KEY = ["pago-movil-accounts"] as const;

export const usePagoMovilAccounts = () => {
  const query = useQuery<PagoMovilAccount[], Error>({
    queryKey: PAGO_MOVIL_ACCOUNTS_QUERY_KEY,
    queryFn: getPagoMovilAccountsService,
    staleTime: 5 * 60_000,
  });

  return {
    accounts: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};

export const useCreatePagoMovilAccount = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation<unknown, Error, CreatePagoMovilAccountPayload>({
    mutationFn: createPagoMovilAccountService,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: PAGO_MOVIL_ACCOUNTS_QUERY_KEY});
    },
  });

  return mutation;
};

export const useUpdatePagoMovilAccount = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation<unknown, Error, UpdatePagoMovilAccountPayload>({
    mutationFn: updatePagoMovilAccountService,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: PAGO_MOVIL_ACCOUNTS_QUERY_KEY});
    },
  });

  return mutation;
};

export const useDeletePagoMovilAccount = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation<unknown, Error, string>({
    mutationFn: deletePagoMovilAccountService,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: PAGO_MOVIL_ACCOUNTS_QUERY_KEY});
    },
  });

  return mutation;
};
